import { useBilling } from '@/contexts/BillingContext'
import { AlertTriangle, XCircle } from 'lucide-react'
import { router } from '@inertiajs/react'

interface UsageBannerProps {
  orgSlug: string
}

export function UsageBanner({ orgSlug }: UsageBannerProps) {
  const { billing, isUsageWarning, isUsageCritical, usagePercentage } = useBilling()

  if (!billing || (!isUsageWarning && !isUsageCritical) || billing.status === 'trialing') {
    return null
  }

  const handleBuyPack = () => {
    router.post(`/${orgSlug}/billing/checkout_pack`)
  }

  if (isUsageCritical) {
    return (
      <div className="bg-red-500/10 border-b border-red-500/20 px-4 py-2">
        <div className="flex items-center justify-between max-w-7xl mx-auto">
          <div className="flex items-center gap-2 text-red-600 text-sm">
            <XCircle className="h-4 w-4" />
            <span>
              Has alcanzado el límite de conversaciones de tu plan.
              {billing.usage.pack_credits_remaining > 0 && (
                <span className="ml-1">
                  ({billing.usage.pack_credits_remaining} créditos extra disponibles)
                </span>
              )}
            </span>
          </div>
          <button
            onClick={handleBuyPack}
            className="text-sm font-medium text-red-600 hover:text-red-700 underline"
          >
            Comprar +300 conversaciones
          </button>
        </div>
      </div>
    )
  }

  if (isUsageWarning) {
    return (
      <div className="bg-yellow-500/10 border-b border-yellow-500/20 px-4 py-2">
        <div className="flex items-center justify-between max-w-7xl mx-auto">
          <div className="flex items-center gap-2 text-yellow-600 text-sm">
            <AlertTriangle className="h-4 w-4" />
            <span>
              Has usado {usagePercentage}% de tus conversaciones (
              {billing.usage.conversations_used}/{billing.usage.total_available}).
            </span>
          </div>
          <button
            onClick={handleBuyPack}
            className="text-sm font-medium text-yellow-600 hover:text-yellow-700 underline"
          >
            Comprar +300 conversaciones
          </button>
        </div>
      </div>
    )
  }

  return null
}
